import React from 'react'
import { MdStar } from 'react-icons/md'
import type { Property } from 'csstype'
import { findContrastColor } from 'services/color'
import ContactButton from 'components/ContactButton'
import { classNames } from 'services/string'

export interface IDetailedCustomerReviewCardProps {
  className?: string
  redirectToTarget?: boolean
  review: Queries.ReviewInfoFragment
  primaryColor?: Property.Color
  secondaryColor?: Property.Color
}

const DetailedCustomerReviewCard = ({
  className,
  review,
  redirectToTarget,
  primaryColor,
  secondaryColor,
}: IDetailedCustomerReviewCardProps) => {
  const primaryContrastColor = findContrastColor(primaryColor || 'var(--color-primary-600)')
  const secondaryContrastColor = findContrastColor(secondaryColor || 'var(--color-primary-100)')

  return (
    <div
      className={classNames(
        className,
        'rounded-2xl flex flex-col justify-between p-8 h-auto gap-4 bg-white/50 shadow-[1px_1px_1px_0px_rgba(255,255,255,1)_inset] text-black',
      )}
    >
      <div className='flex flex-col gap-2'>
        <p className='font-medium text-xl'>"{review.title}"</p>

        <div className='flex gap-1 text-primary-600'>
          {[...Array(5)].map((_v, i) => (
            <MdStar key={i} size={25} />
          ))}
        </div>
      </div>
      <p className='text-lg'>"{review.content}"</p>

      <ContactButton
        redirectToTarget={redirectToTarget}
        componentName='ReviewCarousel'
        label='Eu também quero ser Cliente Hubs!'
        targetId='contact-section'
        className='!drop-shadow-xs w-full md:w-auto'
        colorSchema='styled'
        style={{
          backgroundColor: primaryColor || 'var(--color-primary-600)',
          color: primaryContrastColor,
        }}
      />
    </div>
  )
}

export default DetailedCustomerReviewCard
